const Sounds = {
  Point: "point",
  Set: "set",
  Winning: "winning",
};

export default Sounds;